import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, ElementRef, HostListener, inject, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { LoginResponse, OidcSecurityService } from "angular-auth-oidc-client";
import { CookieService } from "ngx-cookie-service";
import { filter, map } from "rxjs/operators";
import { IBlog } from "src/app/shared/interfaces/blog";
import { ICategory } from "src/app/shared/interfaces/category";
import { IDoctor } from "src/app/shared/interfaces/doctor";
import { IFrequentlyQuestion } from "src/app/shared/interfaces/frequentlyQuestion";
import { FakeDataService } from "src/app/shared/mock/fake-data.service";
import { ApiService } from "src/app/shared/services/api.service";
import { SearchService } from "src/app/shared/services/search.service";
// import { CustomStorageService2 } from "src/app/shared/services/storage.service";


@Component({
  selector: "app-landing",
  styleUrl: "./landing.component.css",
  templateUrl: "./landing.component.html",
})
export class LandingComponent implements OnInit {

  doctors: IDoctor[];
  error: string;
  questions: IFrequentlyQuestion[];
  medicalCategory: ICategory[]; 
  blogList: IBlog[];
  isAuthenticated: boolean;
  pageSize: number = 30;

  returnURL;

  constructor(translate: TranslateService,
    private http: HttpClient,
    private cookies: CookieService,
    private fakeDataService: FakeDataService,
    private searchService: SearchService,
    public apiService: ApiService,
    public router: Router,
    private route: ActivatedRoute,
    private oidcSecurityService: OidcSecurityService
  ) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang(this.cookies.get('lang'));
    // console.log(this.cookies.get('lang'));

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // translate.use('fa');

  }


  ngOnInit(): void {

    

    if (localStorage.getItem('returnUrl')) {        
      this.returnURL = localStorage.getItem('returnUrl');

      this.router.navigate([this.returnURL]);
    }

    this.getTopDoctors();
    this.getFrequentlyQuestions();
    // this.getTopCategories();
    this.getTopBlog();
    

     // Check if URL contains the authorization code (return from IdP)
     const code = this.route.snapshot.queryParamMap.get('code');
      
     if (code || code != null) {
      //  console.log('Returned from IdP with code:', code);
       
       // Call checkAuth() to process the authentication
       this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
         this.isAuthenticated = isAuthenticated;
        //  console.log('User is authenticated:', isAuthenticated);
 
         if (!isAuthenticated) {
          //  console.warn('Authentication failed. Trying to log in again...');
          this.oidcSecurityService.authorize(undefined, {
            customParams: {
              requestCulture: 'fa-IR'
            }
          });
         }
       });
     } else {
       // Normal authentication check when loading the app
      //  this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      //    this.isAuthenticated = isAuthenticated;
      //    console.log('User is authenticated:', isAuthenticated);
 
      //    if (!isAuthenticated) {
      //      console.warn('User is not authenticated. Redirecting to login...');
      //      this.oidcSecurityService.authorize();
      //    }
      //  });
     }
    
  }


  searchByCategory(query) {
    this.apiService.apiCall('get', '/api/SiteDoctors/GetAllDoctors?search='+query).subscribe((res: any) => {
      console.log(res);

      this.searchService.updateSearchResults(res.body.model)
      this.router.navigate(['/doctors-list'])
    });
  }

  // Update the carousel position
  itemsPerPage: number = 3;
  currentIndex: number = 0;

  get totalPages(): number {
    return Math.ceil(this.doctors?.length / this.itemsPerPage);
  }

  updateCarousel(indexChange: number): void {
    // const newIndex = this.currentIndex + indexChange;
    // if (newIndex >= 0 && newIndex < this.totalPages) {
    //   this.currentIndex = newIndex;
    // }

    // Infinite Loop for the Carousel
    this.currentIndex = (this.currentIndex + indexChange + this.totalPages) % this.totalPages;

  }

  getTopDoctors() {
    // this.fakeDataService.getDoctor().subscribe({
    //   next: (doctor) => {
    //     this.doctors = doctor;
    //   },
    //   error: (err) => {
    //     this.error = 'Failed to load user' + err;
    //   }

    // });

    this.apiService.apiCall('get', '/api/SiteDoctors/GetAllDoctors?MostPopular=true&PageIndex=1&PageSize=9', {}).subscribe((res: any) => {
      console.log(res);

      this.doctors = res.body.model;
      
    })
  }

  onSearch(query: string){
    // This would be your search logic
    // return [{ name: 'Result 1' }, { name: 'Result 2' }];  // Example results

    const params = {
      pageSize: this.pageSize,
      pageIndex: 1,
      search: query
    }

    this.apiService.apiCall('get', '/api/SiteDoctors/GetAllDoctors', {}, params).subscribe((res: any) => {
      console.log(res);

      this.searchService.updateSearchResults(res.body.model)
      this.router.navigate(['/doctors-list'])
    });

    // return this.searchResult
  }

  getTopCategories() {
    // this.fakeDataService.getCategories().subscribe({
    //   next: (cat) => {
    //     this.medicalCategory = cat;
    //   },
    //   error: (err) => {
    //     this.error = 'Failed to load user' + err;
    //   }
    // });

    const params = {
      // ID: null,
      // Title: null,
      PageIndex: 1,
      PageSize: 5
    }
    this.apiService.apiCall('get', '/api/SiteCategories/GetAllCategories', {}, params).subscribe((res: any) => {
      console.log(res);
      this.medicalCategory = res.body.model;
    })
  }


  getTopBlog() {
    // this.fakeDataService.getBlogs().subscribe((res: any) => {
    //   this.blogList = res;
    // })

    const params = {
      PageIndex: 1,
      pageSize: 3
    }

    this.apiService.apiCall('get', '/api/SitesBlog/GetAllSiteBlogs', {} , params).subscribe((res: any) => {
      console.log(res);
      this.blogList = res.body.model;
      
    })
  }


  // Accordion Data
  openAccordionIndex: number | null = 0;

  getFrequentlyQuestions() {

    // this.fakeDataService.getQuestions().subscribe({
    //   next: (q) => {
    //     this.questions = q;
    //   },
    //   error: (err) => {
    //     this.error = 'Failed to load questions' + err;
    //   }
    // });

    this.apiService.apiCall('get', '/api/SiteInfo/GetAllFaq').subscribe((res: any) => {
      this.questions = res.body.model;
    })
  }

  toggleAccordion(index: number) {
    if (this.openAccordionIndex === index) {
      this.openAccordionIndex = null;
    } else {
      this.openAccordionIndex = index;
    }
  }

}
